import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const VerticalCardContainer = styled.div<React.CSSProperties>`
  border: ${4 * Screen.widthRatio}px solid transparent;
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${300 * Screen.widthRatio}px;
  margin-right: ${4 * Screen.widthRatio}px;
  overflow: hidden;
  width: ${200 * Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default VerticalCardContainer;
